import { get } from '../ah-http-service';
import * as Cookies from 'js-cookie';
import {
  LAST_REQUEST_KEY_NAME,
  REQUEST_TIMEOUT,
  SESSION_ID_COOKIE_NAME,
  VIEWBEAN_URL
} from './constants.js';

export function isLastRequestValid() {
  let result = false;
  const lastRequestDate = sessionStorage.getItem(LAST_REQUEST_KEY_NAME);
  if (lastRequestDate) {
    const now = new Date();
    const dlr = new Date(lastRequestDate);
    const diff = now.getTime() - dlr.getTime();
    result = diff < REQUEST_TIMEOUT;
  }
  return result;
}

export function getViewBeansUrl(sessionId) {
  let url = VIEWBEAN_URL;
  if (sessionId) {
    url += '&httpSessionId=' + sessionId;
  } else {
    url += '&referer=' + encodeURIComponent(window.document.referrer);
  }
  return url;
}

export function getSessionId() {
  return Cookies.get(SESSION_ID_COOKIE_NAME);
}

export async function getNewSessionId(url) {
  try {
    console.log('### Getting new session ID...');
    await get(url);
    const sessionId = getSessionId();
    console.log('### New Session ID:', sessionId);
    return sessionId;
  } catch (error) {
    console.log('error on getNewSessionId', error);
    throw Error(error);
  }
}

export function saveTimestamp() {
  sessionStorage.setItem(LAST_REQUEST_KEY_NAME, new Date().toJSON());
}

export function deleteTimestamp() {
  sessionStorage.removeItem(LAST_REQUEST_KEY_NAME);
}
